<template>
  <SectionPanel
    :step="2"
    :candidate="candidate"
    description="Dónde vive y cómo llegar a su casa."
    @edit="(step) => $emit('edit', step)"
  >
    <InlineSectionEditor
      ref="editor"
      :step="2"
      :candidate="candidate"
      :user-email="userEmail"
      @dirty="(value) => $emit('dirty', value)"
      @saved="(step) => $emit('saved', step)"
      @autosaved="(event) => $emit('autosaved', event)"
      @autosave-blocked="(missing) => $emit('autosave-blocked', missing)"
      @autosave-failed="(message) => $emit('autosave-failed', message)"
    />
  </SectionPanel>
</template>

<script>
import InlineSectionEditor from "./InlineSectionEditor.vue";
import SectionPanel from "./SectionPanel.vue";

// Residencia: the address, the pin on the map and the croquis, edited right here.
export default {
  name: "PortalResidenceTab",
  components: { InlineSectionEditor, SectionPanel },
  props: {
    candidate: { type: Object, required: true },
    userEmail: { type: String, default: "" },
  },
  methods: {
    // Saves what is waiting before leaving the section (see InlineSectionEditor's flush()).
    flush() {
      return this.$refs.editor ? this.$refs.editor.flush() : Promise.resolve(true);
    },
  },
};
</script>
